<template>
    <div v-if="deleteProduct" class="mobile-menu">
        <div class="mobile-menu__container js-mobile-menu-container">
            <div class="mobile-menu__container-inner">
                <div class="mobile-menu__content mb-auto">
                    <div class="product-info">
                        <div class="product-info-img" v-if="item.product.thumb_image" :style="`background-image: url(${item.product.thumb_image})`"></div>
                        <div v-else class="product-info-no-img"></div>
                        <div class="product-info-title">{{ $t('delete_product_title', {productName: item.product.name}) }}</div>
                        <div class="product-info-description" v-html="$tc('delete_product_description', item.product.photos_quantity, {productName: item.product.name, photosQuantity: item.product.photos_quantity})"></div>
                    </div>
                </div>
            </div>
        </div>
        <a href="#" @click.prevent="$store.dispatch('SET_MOBILE_CART_DELETE_MENU', false)" class="mobile-menu__action-back-btn -bottom">
            <span class="material-icon icon-keyboard_arrow_left"/>
        </a>
        <a href="#" @click.prevent="deleteItem" class="mobile-menu__btn -bottom -green">
            <span class="material-icon icon-check"/>
        </a>
    </div>
</template>

<style lang="scss" scoped>
    .product-info {
        text-align: center;

        &-img,
        &-no-img {
            width: 140px;
            height: 140px;
            margin: 0 auto 36px;
            border-radius: 50%;
            background: 50% 50% no-repeat;
            background-size: cover;
        }

        &-no-img {
            background-image: url('../assets/no-preview-large.jpg');
        }

        &-title {
            margin-bottom: 20px;
            font-size: 1.25rem;
        }

        &-description {
            font-size: 1rem;
        }
    }
</style>

<script>
  import mobileCartDeleteMenu from 'src/mixins/mobileCartDeleteMenuComponent';
  import cart from 'src/mixins/cartComponent';

  export default {
    mixins: [mobileCartDeleteMenu, cart],
  };
</script>
